import React from 'react';
import SEO from '../components/SEO';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <>
      <SEO
        title="Privacy Policy"
        description="Privacy Policy for JVP Health Tech Solutions — how we collect, use, and protect your information."
        url="https://www.jvphealthtechsolutions.com/privacy-policy"
      />
      <div className="page" style={{ paddingTop: '80px' }}>
        <div style={{ maxWidth: '860px', margin: '0 auto', padding: '4rem 2rem', color: 'var(--color-text-label)', lineHeight: 1.8, textAlign: 'left' }}>
          <h1 style={{ color: 'var(--color-text)', fontSize: '2.4rem', marginBottom: '0.25rem' }}>Privacy Policy</h1>
          <p style={{ color: 'var(--color-text-muted)', fontSize: '0.95rem', marginBottom: '2.5rem' }}>Last updated: January 1, 2026</p>

          <h2 style={{ color: 'var(--color-text)' }}>1. Introduction</h2>
          <p>JVP Health Tech Solutions ("Company," "we," "us," or "our") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or contact us for services.</p>

          <h2 style={{ color: 'var(--color-text)' }}>2. Information We Collect</h2>
          <p>We may collect the following types of information:</p>
          <ul style={{ paddingLeft: "1.75rem" }}>
            <li><strong>Contact Information:</strong> Name, email address, phone number, and facility name when you submit a contact form or request a quote.</li>
            <li><strong>Usage Data:</strong> IP address, browser type, pages visited, and time spent on our website, collected automatically through standard web technologies.</li>
            <li><strong>Communications:</strong> Any messages, inquiries, or correspondence you send to us.</li>
          </ul>
          <p>We do not collect sensitive personal health information (PHI) through this website.</p>

          <h2 style={{ color: 'var(--color-text)' }}>3. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul style={{ paddingLeft: "1.75rem" }}>
            <li>Respond to your inquiries and provide requested services</li>
            <li>Send service-related communications and follow-ups</li>
            <li>Improve our website and service offerings</li>
            <li>Comply with applicable legal obligations</li>
          </ul>
          <p>We do not sell, rent, or trade your personal information to third parties for marketing purposes.</p>

          <h2 style={{ color: 'var(--color-text)' }}>4. Disclosure of Information</h2>
          <p>We may share your information only in the following circumstances:</p>
          <ul style={{ paddingLeft: "1.75rem" }}>
            <li><strong>Service Providers:</strong> Trusted third-party vendors who assist in operating our website or conducting our business, subject to confidentiality obligations.</li>
            <li><strong>Legal Requirements:</strong> When required by law, court order, or governmental authority.</li>
            <li><strong>Business Transfers:</strong> In connection with a merger, acquisition, or sale of company assets, with appropriate notice to you.</li>
            <li><strong>Protection of Rights:</strong> To protect the rights, property, or safety of JVP Health Tech Solutions, our clients, or others.</li>
          </ul>

          <h2 style={{ color: 'var(--color-text)' }}>5. Data Security</h2>
          <p>We implement reasonable administrative, technical, and physical safeguards to protect your information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.</p>

          <h2 style={{ color: 'var(--color-text)' }}>6. Cookies and Tracking</h2>
          <p>Our website may use cookies and similar tracking technologies to enhance your browsing experience and analyze site traffic. You may disable cookies through your browser settings; however, some features of the site may not function properly as a result.</p>

          <h2 style={{ color: 'var(--color-text)' }}>7. Third-Party Links</h2>
          <p>Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites and encourage you to review their privacy policies independently.</p>

          <h2 style={{ color: 'var(--color-text)' }}>8. Children's Privacy</h2>
          <p>Our website is not directed to individuals under the age of 18. We do not knowingly collect personal information from minors. If you believe we have inadvertently collected such information, please contact us immediately.</p>

          <h2 style={{ color: 'var(--color-text)' }}>9. Your Rights</h2>
          <p>Depending on your location, you may have the right to access, correct, or request deletion of your personal information. To exercise these rights, please contact us at the information below.</p>

          <h2 style={{ color: 'var(--color-text)' }}>10. Changes to This Policy</h2>
          <p>We reserve the right to update this Privacy Policy at any time. Changes will be posted on this page with an updated effective date. Continued use of our website after changes constitutes acceptance of the revised policy.</p>

          <h2 style={{ color: 'var(--color-text)' }}>11. Contact Us</h2>
          <p>If you have questions or concerns about this Privacy Policy, please contact us at:</p>
          <p><strong>JVP Health Tech Solutions</strong><br />
          Email: <a href="mailto:info@jvphealthtechsolutions.com" style={{ color: 'var(--color-primary)' }}>info@jvphealthtechsolutions.com</a></p>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
